// extracted by mini-css-extract-plugin
export default {"container":"PageLoader_container__Fz+JF","title":"PageLoader_title__p-V1q","subtitle":"PageLoader_subtitle__i1g+D"};